angular.module('impactx.panel').controller('ProductGroupPanelCtrl', [
    'TranslationService',
    'AppConfiguration',
    'SearchFilter',
    'searchFilter',
    ProductGroupPanelCtrl]);

function ProductGroupPanelCtrl(TranslationService, AppConfiguration, SearchFilter, searchFilter) {
    var self = this;

    self.showPanelLabel = AppConfiguration.get('showPanelLabels');

    self.filterProductGroup = function() {
       SearchFilter.filterProductGroup(self.productGroup, searchFilter);
    };

    self.$onInit = function(){
        self.trns = {
            productLabel: (self.productGroup.numberOfProducts > 1 || self.productGroup.numberOfProducts === 0) ?
                TranslationService.get('products') : TranslationService.get('product')
        };
    };
}